import React from 'react';
import PropTypes from 'prop-types';
import PageHeader from '../PageHeader/index.js';
import { Image } from '../../Atoms';

const PageBody = ({ title = '', intro = '', description = '', image, children }) => {
  const hasHeader = Boolean(title || intro);
  return (
    <>
      {hasHeader && (
        <PageHeader title={title} intro={intro} description={description} />
      )}

      {/* ❌ WRONG: page-featured was nested inside the sections container.
            DOM Assembly shows it as a sibling of page-body, sitting BETWEEN
            page__header and page-body — not inside page-body.
            REMOVED FROM HERE → placed as sibling above page-body below. */}

      {/* ✅ CORRECT: page-featured is a sibling of page-body, not a child.
            DOM Assembly node [5b] sits between page__header and page-body. */}
      {image && (
        <div className="page-featured">
          <Image image={image} />
        </div>
      )}

      {/* ❌ WRONG: was className="page__body"
            page__body (double underscore) is slot syntax — it does not exist
            in the CSS. The actual class that owns flow spacing between sections
            is page-body (single hyphen). Wrong class = no spacing rules apply. */}

      {/* ✅ CORRECT: page-body (single hyphen) */}
      <div className="page-body">
        {children}
      </div>
    </>
  );
};

PageBody.propTypes = {
  title: PropTypes.string,
  intro: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
};

export default PageBody;